import { toast } from "react-toastify";
import { jobProfileConstants } from "../constants";
import { jobProfileService } from "../services";

const getAllProfiles = () => {
  const request = () => {
    return { type: jobProfileConstants.GETALL_REQUEST };
  };
  const success = (jobProfile) => {
    return { type: jobProfileConstants.GETALL_SUCCESS, jobProfile };
  };
  const jobLoader = (jobLoader) => {
    return { type: jobProfileConstants.GETALL_SUCCESS_LOADER, jobLoader };
  };
  const failure = (error) => {
    return { type: jobProfileConstants.GETALL_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    jobProfileService.getAllProfiles().then((jobProfile, error) => {
      if (jobProfile) {
        dispatch(success(jobProfile));
        dispatch(jobLoader(true));
      } else {
        dispatch(failure(error.toString()));
      }
    });
  };
};

const createProfile = (createData) => {
  const request = (profile) => {
    return { type: jobProfileConstants.CREATE_REQUEST, profile };
  };
  const success = (profile) => {
    return { type: jobProfileConstants.CREATE_SUCCESS, profile };
  };
  const failure = (error) => {
    return { type: jobProfileConstants.CREATE_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(createData));
    return jobProfileService.createProfile(createData).then(
      (profile) => {
        // toast.success("Opening Created");
        dispatch(success(profile));
        return profile;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
      }
    );
  };
};

const updateJobProfile = (updateData, id) => {
  const request = (profile) => {
    return { type: jobProfileConstants.UPDATE_REQUEST, profile };
  };
  const success = (profile) => {
    return { type: jobProfileConstants.UPDATE_SUCCESS, profile };
  };
  const failure = (error) => {
    return { type: jobProfileConstants.UPDATE_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(updateData));
    return jobProfileService.updateProfile(updateData, id).then(
      (profile) => {
        // toast.success("Opening Updated ");
        dispatch(success(profile));
        return profile;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
      }
    );
  };
};

const deleteJobProfile = (id) => {
  const request = (id) => {
    return { type: jobProfileConstants.DELETE_REQUEST, id };
  };
  const success = (id) => {
    return { type: jobProfileConstants.DELETE_SUCCESS, id };
  };
  const failure = (id, error) => {
    return { type: jobProfileConstants.DELETE_FAILURE, id, error };
  };

  return (dispatch) => {
    dispatch(request(id));
    jobProfileService.deleteProfile(id).then(
      (res) => {
        // toast.success("Opening Deleted");
        dispatch(success(id));
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(id, error.toString()));
      }
    );
  };
};

const getAssignee = (query) => {
  const request = (assignee) => {
    return { type: jobProfileConstants.GET_REQUEST, assignee };
  };
  const success = (assignee) => {
    return { type: jobProfileConstants.GET_SUCCESS, assignee };
  };
  const failure = (error) => {
    return { type: jobProfileConstants.GET_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    jobProfileService.getAssignee(query).then((assignee, error) => {
      if (assignee) {
        dispatch(success(assignee));
      } else {
        dispatch(failure(error.toString()));
      }
    });
  };
};

const getCluster = (query) => {
  const request = (cluster) => {
    return { type: jobProfileConstants.GETCLUSTERLIST_REQUEST, cluster };
  };
  const success = (cluster) => {
    return { type: jobProfileConstants.GETCLUSTERLIST_SUCCESS, cluster };
  };
  const failure = (error) => {
    return { type: jobProfileConstants.GETCLUSTERLIST_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    jobProfileService.getCluster(query).then((cluster, error) => {
      if (cluster) {
        dispatch(success(cluster));
      } else {
        dispatch(failure(error.toString()));
      }
    });
  };
};

const getSearchApi = (query) => {
  const request = (searchUser) => {
    return { type: jobProfileConstants.GETSEARCHUSER_REQUEST, searchUser };
  };
  const success = (searchUser) => {
    return { type: jobProfileConstants.GETSEARCHUSER_SUCCESS, searchUser };
  };
  const failure = (error) => {
    return { type: jobProfileConstants.GETSEARCHUSER_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    jobProfileService.getSearchApi(query).then((serchUser, error) => {
      if (serchUser) {
        dispatch(success(serchUser));
      } else {
        dispatch(failure(error.toString()));
      }
    });
  };

}

const getAuthSearch = (query) => {
  const request = (inetviewer) => {
    return { type: jobProfileConstants.GETINTERVIEW_REQUEST, inetviewer };
  };
  const success = (inetviewer) => {
    return { type: jobProfileConstants.GETINTERVIEW_SUCCESS, inetviewer };
  };
  const failure = (error) => {
    return { type: jobProfileConstants.GETINTERVIEW_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    jobProfileService.getAuthSearch(query).then((inetviewer, error) => {
      if (inetviewer) {
        dispatch(success(inetviewer));
      } else {
        dispatch(failure(error.toString()));
      }
    });
  };
};

const getMasterData = (type) => {
  const request = (masterData) => {
    return { type: jobProfileConstants.GETJOB_REQUEST, masterData };
  };
  const success = (masterData) => {
    return { type: jobProfileConstants.GETJOB_SUCCESS, masterData };
  };
  const failure = (error) => {
    return { type: jobProfileConstants.GETJOB_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    jobProfileService.getMasterData(type).then((masterData, error) => {
      if (masterData) {
        dispatch(success(masterData));
      } else {
        dispatch(failure(error.toString()));
      }
    });
  };
};

const getAllReferral = () => {
  const request = (referralData) => {
    return { type: jobProfileConstants.GET_REFERRAL_REQUEST, referralData };
  };
  const success = (referralData) => {
    return { type: jobProfileConstants.GET_REFERRAL_SUCCESS, referralData };
  };
  const failure = (error) => {
    return { type: jobProfileConstants.GET_REFERRAL_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    jobProfileService.getAllReferral().then((referralData, error) => {
      if (referralData) {
        dispatch(success(referralData));
      } else {
        dispatch(failure(error.toString()));
      }
    });
  };
};

const getjobIds = () => {
  const request = (jobData) => {
    return { type: jobProfileConstants.GETJOBLIST_REQUEST, jobData };
  };
  const success = (jobData) => {
    return { type: jobProfileConstants.GETJOBLIST_SUCCESS, jobData };
  };
  const failure = (error) => {
    return { type: jobProfileConstants.GETJOBLIST_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    jobProfileService.getjobIds().then((jobData, error) => {
      if (jobData) {
        dispatch(success(jobData));
      } else {
        dispatch(failure(error.toString()));
      }
    });
  };
};

const getCities = (country) => {
  const request = (data) => {
    return { type: jobProfileConstants.GETCITIES_REQUEST, data };
  };
  const success = (data) => {
    return { type: jobProfileConstants.GETCITIES_SUCCESS, data };
  };
  const failure = (error) => {
    return { type: jobProfileConstants.GETCITIES_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    jobProfileService.getCities(country).then((data, error) => {
      if (data?.data) {
        dispatch(success(data?.data));
      } else {
        dispatch(failure(error.toString()));
      }
    });
  };
}

export const jobProfileActions = {
  getAllProfiles,
  createProfile,
  updateJobProfile,
  deleteJobProfile,
  getAssignee,
  getMasterData,
  getjobIds,
  getCluster,
  getAuthSearch,
  getSearchApi,
  getCities,
  getAllReferral
};
